<div class="matrix_layoutMain container"  v-bind:class="getClassNameContainer">
    <div class="row">
        <div class="col-md-12" >                
            <appCostCenter></appCostCenter>
            <appQuantityTable v-if="!getCimpressNoQuantity">
                <appQuantityContainer></appQuantityContainer>
                <appInputQuantity></appInputQuantity>
            </appQuantityTable>
            <appAddToCartButton class="matrix_addToCartButtonMain" style="display:none"></appAddToCartButton>
            <appOtherOptionsTable>
                <appOtherOptionsContainer></appOtherOptionsContainer>
            </appOtherOptionsTable>
            <appOptionsTable>
                <appOptionsContainer></appOptionsContainer>
                <appInputCustomFormatInsert></appInputCustomFormatInsert>
            </appOptionsTable>
            <appQuantityTable v-if="getCimpressNoQuantity">
                <appQuantityContainer></appQuantityContainer>
                <appInputQuantity></appInputQuantity>
            </appQuantityTable>
            <appPersonalizationButton></appPersonalizationButton>
            <appAddToCartButton class="matrix_addToCartButtonMobile" style="display:none"></appAddToCartButton>   
            <appQuotationButton></appQuotationButton>             
        </div>
    </div>    
</div>